module.exports = __webpack_public_path__ + "fb.svg?1f363eaa46e2ca26b4df1cb77e08be91";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fb.svg
// module id = 77
// module chunks = 0